import { render, staticRenderFns } from "./HightlightsListItem.vue?vue&type=template&id=25fc20fc&scoped=true&"
import script from "./HightlightsListItem.vue?vue&type=script&lang=js&"
export * from "./HightlightsListItem.vue?vue&type=script&lang=js&"
import style0 from "./HightlightsListItem.vue?vue&type=style&index=0&id=25fc20fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fc20fc",
  null
  
)

export default component.exports